<template>
    <div class="update-citime-container" v-loading="isLoading">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form class="form" @submit.prevent="handleSubmit(summit)" autocomplete="off">
                <input 
                    type="file" 
                    ref="hiddenFileInput" 
                    class="d-none" 
                    accept="image/jpeg, image/png, image/webp, .heic" 
                    @change="handleFileSelected" 
                />

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                           <label class="form-label col-form-label mr-3">Người trả góp <span class="text-danger">*</span></label>
                           <el-radio-group :disabled="ageCustomer < 15" v-model="payer.payer_selected" class="card-payment-plan-group">
                                <el-radio v-for="p in payers" :key="p.id" :label="p.id">{{ p.label }}</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Họ và tên <span class="text-danger">*</span></label>
                            <ValidationProvider vid="name" name="Họ và tên" rules="required" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" filterable class="w-100" placeholder="Họ và tên" v-model="payer.name"></el-input>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                    <div v-if="scanErrors.payer_name" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_name }}</div>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Số điện thoại<span class="text-danger">*</span></label>
                            <ValidationProvider vid="phone" name="Số điện thoại" :rules="{ required: true, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" @input="checkUniquePhone" filterable class="w-100" placeholder="Số điện thoại" v-model="payer.phone"></el-input>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Địa chỉ <span class="text-danger">*</span></label>
                            <ValidationProvider vid="address" name="Nhập địa chỉ" :rules="{ required: true}" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" v-model="payer.address" filterable class="w-100" placeholder="Nhập địa chỉ"></el-input>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Quê quán(CCCD)</label>
                            <ValidationProvider vid="place_of_residence" name="Nhập quê quán" :rules="{ required: false }" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" v-model="payer.place_of_residence" filterable class="w-100" placeholder="Nhập quê quán theo cccd"></el-input>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Số điện thoại khác</label>
                            <ValidationProvider vid="phone_other" name="Nhập số điện thoại khác" :rules="{ required: false, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" v-model="payer.phone_other" filterable class="w-100" placeholder="Nhập số điện thoại khác"></el-input>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Ngày sinh<span class="text-danger">*</span></label>
                            <ValidationProvider vid="birthday" name="Ngày sinh" rules="required" v-slot="{ errors }">
                                <el-date-picker :disabled="isDisabled"
                                    v-model="payer.birthday" type="date" format="dd-MM-yyyy" value-format="yyyy-MM-dd"
                                    placeholder="Nhập ngày sinh" class="w-100"
                                ></el-date-picker>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                    <div v-if="scanErrors.payer_birthday" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_birthday }}</div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Căn cước công dân <span class="text-danger">*</span></label>
                            <ValidationProvider vid="cccd" name="Căn cước công dân" :rules="{ required: true, regex: /^[0-9]{9}([0-9]{3})?$/ }" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" v-model="payer.cccd" filterable class="w-100" placeholder="Nhập căn cước công dân"></el-input>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                    <div v-if="scanErrors.payer_cccd" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_cccd }}</div>
                                    <div v-if="scanErrors.payer_cccd_match" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_cccd_match }}</div>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Ngày cấp <span class="text-danger">*</span></label>
                            <ValidationProvider vid="cccd_issued_date" name="Ngày cấp CCCD" :rules="{ required: true }" v-slot="{ errors }">
                                <el-date-picker :disabled="isDisabled" v-model="payer.cccd_issued_date" type="date" format="dd-MM-yyyy" value-format="yyyy-MM-dd" placeholder="Ngày cấp CCCD" class="w-100"></el-date-picker>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                    <div v-if="scanErrors.payer_cccd_issued_date" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_cccd_issued_date }}</div>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Nơi cấp <span class="text-danger">*</span></label>
                            <ValidationProvider vid="cccd_issued_place" name="Nơi cấp CCCD" :rules="{ required: true }" v-slot="{ errors }">
                                <el-input :disabled="isDisabled" v-model="payer.cccd_issued_place" filterable class="w-100" placeholder="Nơi cấp CCCD" ></el-input>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                    <div v-if="scanErrors.payer_cccd_issued_place" class="fv-help-block text-danger mt-1">{{ scanErrors.payer_cccd_issued_place }}</div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group" v-if="!isDisabled">
                            <div class="row mt-3">
                                <div class="col-md-6 mb-2">
                                    <div class="upload-box text-center p-3 border-dashed rounded position-relative" 
                                         @click="triggerUpload('citime_cccd_front')" 
                                         v-loading="uploadingState['citime_cccd_front']">
                                        <template v-if="payer.cccd_front_url">
                                            <img :src="payer.cccd_front_url" class="img-preview" />
                                            <div class="mt-2 text-primary small"><i class="el-icon-edit"></i> Đổi ảnh</div>
                                        </template>
                                        <template v-else>
                                            <i class="el-icon-picture-outline text-muted" style="font-size: 24px;"></i>
                                            <p class="mb-0 mt-2 font-weight-bold">Mặt trước CCCD <span class="text-danger">*</span></p>
                                        </template>
                                    </div>
                                    <span v-if="errors.cccd_front_url" class="text-danger small">{{ errors.cccd_front_url }}</span>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <div class="upload-box text-center p-3 border-dashed rounded position-relative" 
                                         @click="triggerUpload('citime_cccd_back')" 
                                         v-loading="uploadingState['citime_cccd_back']">
                                        <template v-if="payer.cccd_back_url">
                                            <img :src="payer.cccd_back_url" class="img-preview" />
                                            <div class="mt-2 text-primary small"><i class="el-icon-edit"></i> Đổi ảnh</div>
                                        </template>
                                        <template v-else>
                                            <i class="el-icon-postcard text-muted" style="font-size: 24px;"></i>
                                            <p class="mb-0 mt-2 font-weight-bold">Mặt sau CCCD <span class="text-danger">*</span></p>
                                        </template>
                                    </div>
                                    <span v-if="errors.cccd_back_url" class="text-danger small">{{ errors.cccd_back_url }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Thời gian trả góp<span class="text-danger">*</span></label>
                            <ValidationProvider vid="payment_time" name="Thời gian trả góp" rules="required" v-slot="{ errors }">
                                <el-select filterable class="w-100" placeholder="Chọn thời gian trả góp" v-model="payer.payment_time" clearable>
                                    <el-option v-for="opt in paymentTimeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                                </el-select>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Số tiền trả trước<span class="text-danger">*</span></label>
                            <ValidationProvider vid="installment_fee" name="Số tiền trả trước" rules="required" v-slot="{ errors }">
                                <el-select filterable class="w-100" placeholder="Chọn tỷ lệ trả trước" v-model="payer.installment_fee" clearable :disabled="!payer.payment_time">
                                    <el-option v-for="opt in prepaymentOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                                </el-select>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Thời gian nhận tư vấn<span class="text-danger">*</span></label>
                            <ValidationProvider vid="consultationTimeSlot" name="Thời gian nhận tư vấn" rules="required" v-slot="{ errors }">
                                <el-select filterable class="w-100" placeholder="Chọn thời gian nhận tư vấn" v-model="payer.consultationTimeSlot" clearable>
                                    <el-option v-for="opt in consultingTimeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                                </el-select>
                                <div class="fv-plugins-message-container"><div class="fv-help-block">{{ errors[0] }}</div></div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label">Giấy khai sinh (1 ảnh)</label>
                            <div class="upload-box text-center p-3 border-dashed rounded position-relative" 
                                 @click="triggerUpload('citime_birth_cert')" 
                                 v-loading="uploadingState['citime_birth_cert']">
                                <template v-if="payer.birth_certificate_url">
                                    <img :src="payer.birth_certificate_url" class="img-preview" />
                                    <div class="mt-2 text-primary small"><i class="el-icon-edit"></i> Đổi ảnh</div>
                                </template>
                                <template v-else>
                                    <i class="el-icon-document text-muted" style="font-size: 24px;"></i>
                                    <p class="mb-0 mt-2 font-weight-bold">Tải lên Giấy khai sinh</p>
                                </template>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Phiếu thu hóa đơn thanh toán (1 ảnh)</label>
                            <div class="upload-box text-center p-3 border-dashed rounded position-relative" 
                                 @click="triggerUpload('citime_receipt')" 
                                 v-loading="uploadingState['citime_receipt']">
                                <template v-if="payer.receipt_url">
                                    <img :src="payer.receipt_url" class="img-preview" />
                                    <div class="mt-2 text-primary small"><i class="el-icon-edit"></i> Đổi ảnh</div>
                                </template>
                                <template v-else>
                                    <i class="el-icon-s-ticket text-muted" style="font-size: 24px;"></i>
                                    <p class="mb-0 mt-2 font-weight-bold">Tải lên Phiếu thu</p>
                                </template>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label col-form-label">Chứng minh tài chính (3 ảnh)</label>
                            <div class="row">
                                <div class="col-md-4 mb-2" v-for="i in 3" :key="i">
                                    <div class="upload-box text-center p-3 border-dashed rounded position-relative" 
                                         @click="triggerUpload('citime_finance_' + (i-1))" 
                                         v-loading="uploadingState['citime_finance_' + (i-1)]">
                                        <template v-if="payer.financial_proof_urls[i-1]">
                                            <img :src="payer.financial_proof_urls[i-1]" class="img-preview" />
                                            <div class="mt-2 text-primary small"><i class="el-icon-edit"></i> Đổi ảnh</div>
                                        </template>
                                        <template v-else>
                                            <i class="el-icon-s-finance text-muted" style="font-size: 24px;"></i>
                                            <p class="mb-0 mt-2 font-weight-bold">Ảnh {{i}}</p>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="text-right mt-4 border-top pt-4">
                    <el-button type="primary" native-type="submit">Cập nhật thông tin Citime</el-button>
                </div>
            </form>
        </ValidationObserver>
        <el-dialog title="Cảnh báo sai lệch thông tin" :visible.sync="showMismatchDialog" width="400px">
            <div class="text-danger mb-3 font-weight-bold">
                <i class="el-icon-error"></i> Vui lòng sửa lại các thông tin không khớp với ảnh CCCD trước khi cập nhật!
            </div>
            <ul class="text-danger" style="line-height: 1.8;">
                <li v-for="(err, idx) in mismatchErrors" :key="idx">{{ err }}</li>
            </ul>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showMismatchDialog = false">Đã hiểu & Kiểm tra lại</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { 
    CONTRACT_ONLINE_V2_GET_BY_ID,
    PRESIGNED_UPLOAD_URL,
    SCAN_ID_CARD,
    SCAN_ID_CARD_BACK,
    PAYMENT_TIME_OF_COMBO,
    PREPAYMENT_OF_COMBO,CONTRACT_CITIME_UPDATE_NEW_VERSION
} from "@/core/services/store/contract/contractOnline.module";
import moment from "moment-timezone";
export default {
    name: "UpdateCitime",
    props: {
        id: {
            type: Number,
            default: () => null,
        },
    },
    data() {
        return {
            contract : {},
            isLoading: false,
            isUpload: false,
            currentUploadField: '', 
            uploadingState: {},
            customerBirthday : '',
            consultingTimeOptions: [
                { value: 'MORNING', label: '08:30 - 12:00' },
                { value: 'AFTERNOON', label: '13:30 - 18:00' }
            ],
            courses: [], 
            paymentTimeOptions: [],
            prepaymentOptions: [],
            errors: {
                cccd_front_url: '',
                cccd_back_url: ''
            },
            scanErrors: {
                payer_name: '',
                payer_cccd: '',
                payer_birthday: '',
                payer_cccd_issued_date: '',
                payer_cccd_issued_place: '',
                payer_cccd_match: ''
            },
            centerId : null,
            payer: {
                payer_selected : null,
                name: '',
                phone: '',
                phone_other: '',
                payment_time: '',
                address:'',
                installment_fee: null,
                consultationTimeSlot: '',
                birthday: '', 
                place_of_residence: '', 
                cccd: '', 
                cccd_issued_date: '',
                cccd_issued_place: '',
                cccd_front_url: '',
                cccd_back_url: '',
                birth_certificate_url: '',
                receipt_url: '',
                financial_proof_urls: ['', '', ''],
            },
            scannedData: {
                name: '',
                cccd: '',
                birthday: '',
                cccd_issued_date: '',
                cccd_issued_place: '',
                id_number_back: ''
            },
            showMismatchDialog: false,
            mismatchErrors: [],
            payers : [
                {id : 1 , label : 'Học viên tự trả'},
                {id : 2 , label : 'Người giám hộ trả'}
            ]
        }
    },
    computed : {
        isDisabled() {
            return this.payer.payer_selected == 1 || this.ageCustomer < 15
        },
        ageCustomer(){
            if (!this.customerBirthday) return 99; 
            return moment().diff(this.customerBirthday, "years", true);
        },
    },
    watch: {
        'payer.name'() { this.revalidatePayer(); },
        'payer.cccd'() { 
            this.revalidatePayer(); 
            this.revalidatePayerBack(); 
        },
        'payer.birthday'() { this.revalidatePayer(); },
        'payer.cccd_issued_date'() { this.revalidatePayerBack(); },
        'payer.cccd_issued_place'() { this.revalidatePayerBack(); },
        'payer.payment_time'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchPrepaymentOptions();
            }
        },
        'payer.payer_selected'(newVal, oldVal){
            if(newVal ==2 && oldVal ==1 ) {
                this.payer.name = ''
                this.payer.phone = ''
                this.payer.address = ''
                this.payer.place_of_residence = ''
                this.payer.phone_other = ''
                this.payer.birthday = ''
                this.payer.cccd = ''
                this.payer.cccd_issued_date = ''
                this.payer.cccd_issued_place = ''
                this.payer.cccd_front_url = ''
                this.payer.cccd_back_url = ''
                this.errors = {
                    cccd_front_url: '',
                    cccd_back_url: ''
                }
                this.scanErrors = {
                    payer_name: '',
                    payer_cccd: '',
                    payer_birthday: '',
                    payer_cccd_issued_date: '',
                    payer_cccd_issued_place: '',
                    payer_cccd_match: ''
                }
                this.scannedData = {
                    name: '',
                    cccd: '',
                    birthday: '',
                    cccd_issued_date: '',
                    cccd_issued_place: '',
                    id_number_back: ''
                }
            }
        }
    },
    created() {
        if (this.id) {
            this.fetchContractData();
        }
    },
    methods: {
        async fetchContractData() {
            this.isLoading = true;
            try {
                const res = await this.$store.dispatch(CONTRACT_ONLINE_V2_GET_BY_ID, this.id);
                this.contract = res.data;
                if (this.contract) {
                    await this.fill();
                }
            } catch (error) {
                console.error(error);
                this.$message.error('Không thể lấy thông tin hợp đồng');
            } finally {
                this.isLoading = false;
            }
        },

        async fill() {
            this.courses = this.contract.courses || [];
            this.centerId = this.contract.center_id;
            this.customerBirthday = this.contract.birthday
            if (this.contract.payer) {
                this.payer = { ...this.payer, ...this.contract.payer };
                let proofs = this.contract.payer.financial_proof_urls || [];
                this.payer.financial_proof_urls = [
                    proofs[0] || '', proofs[1] || '', proofs[2] || ''
                ];
                this.scannedData = {
                    name: this.payer.name,
                    cccd: this.payer.cccd,
                    birthday: this.payer.birthday,
                    cccd_issued_date: this.payer.cccd_issued_date,
                    cccd_issued_place: this.payer.cccd_issued_place,
                    id_number_back: this.payer.cccd
                };
            }
            await this.fetchPaymentTimeOptions();
            await this.fetchPrepaymentOptions();
        },

        async fetchPaymentTimeOptions() {
            const courseIds = (this.courses || []).map(course => course?.id).filter(Boolean);
            if (!courseIds.length) return;
            
            try {
                const data = await this.$store.dispatch(PAYMENT_TIME_OF_COMBO, { course_ids: courseIds , center_id : this.centerId});
                if (data && !data.error && data.data) {
                    this.paymentTimeOptions = data.data.map(option => ({
                        value: Number(option?.name),
                        label: `${option?.name} tháng`,
                        idCombo: option.id
                    }));
                }
            } catch (error) {
                console.error("Lỗi lấy danh sách thời gian trả góp: ", error);
            }
        },

        async fetchPrepaymentOptions() {
            if (!this.payer.payment_time || this.paymentTimeOptions.length === 0) {
                this.prepaymentOptions = [];
                return;
            }

            const selectedCombo = this.paymentTimeOptions.find(item => item.value === Number(this.payer.payment_time));
            if (!selectedCombo) {
                this.prepaymentOptions = [];
                return;
            }

            try {
                const data = await this.$store.dispatch(PREPAYMENT_OF_COMBO, { id_combo: selectedCombo.idCombo });
                if (data && data.data) {
                    this.prepaymentOptions = data.data.map(option => ({
                        value: Number(option?.payment_method),
                        label: `${option?.payment_method}%`,
                        interest_rate: option.interest_rate
                    }));
                    const isValidFee = this.prepaymentOptions.some(opt => opt.value === this.payer.installment_fee);
                    if (!isValidFee && this.payer.installment_fee !== null && this.payer.installment_fee !== '') {
                        this.payer.installment_fee = null;
                    }
                }
            } catch (error) {
                console.error("Lỗi lấy danh sách tỷ lệ trả trước: ", error);
            }
        },

        checkUniquePhone() {
            if (this.contract.phone && this.contract.phone !== this.contract.parent.phone) {
                this.$store
                    .dispatch(CHECK_PARENT, { phone: this.contract.parent.phone })
                    .then((data) => {
                        if (data.data) {
                            this.$message.error(
                                "Số điện thoại của phụ huynh không được trùng với số điện thoại của nhân sự công ty. Vui lòng nhập lại đúng thông tin phụ huynh."
                            );
                        }
                    });
            }
        },

        triggerUpload(fieldName) {
            if (this.isUpload) {
                this.$message.warning("Hệ thống đang upload ảnh, vui lòng chờ trong giây lát!");
                return;
            }
            this.currentUploadField = fieldName;
            this.$refs.hiddenFileInput.click();
        },

        async handleFileSelected(event) {
            const file = event.target.files[0];
            if (!file) return;

            event.target.value = ''; 

            const field = this.currentUploadField;
            this.$set(this.uploadingState, field, true);
            this.isUpload = true;

            try {
                const fileType = file.type || (file.name.toLowerCase().endsWith('.heic') ? 'image/heic' : '');
                const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'];
                if (!IMAGE_TYPES.includes(fileType)) {
                    throw new Error('Chỉ hỗ trợ ảnh JPG, PNG, WEBP, HEIC');
                }
                const presignRes = await this.$store.dispatch(PRESIGNED_UPLOAD_URL, { file_type: fileType });
                const { presigned_url, public_url } = presignRes.data || presignRes;

                const putRes = await fetch(presigned_url, {
                    method: 'PUT',
                    headers: { 'Content-Type': fileType, 'x-amz-acl': 'public-read' },
                    body: file,
                });

                if (!putRes.ok) throw new Error(`Upload ảnh lỗi (${putRes.status})`);

                this.mapUrlToField(field, public_url);
                if(field === 'citime_cccd_front') this.errors.cccd_front_url = '';
                if(field === 'citime_cccd_back') this.errors.cccd_back_url = '';

                if (field === 'citime_cccd_front') {
                    await this.processOCRFront(public_url);
                } else if (field === 'citime_cccd_back') {
                    await this.processOCRBack(public_url);
                }
            } catch (error) {
                console.error("Upload error:", error);
                this.$message.error(error.message || "Lỗi khi tải ảnh lên!");
            } finally {
                this.$set(this.uploadingState, field, false);
                this.isUpload = false;
            }
        },

        mapUrlToField(field, url) {
            if (field.startsWith('citime_finance_')) {
                const idx = parseInt(field.split('_')[2]);
                this.$set(this.payer.financial_proof_urls, idx, url);
            } else if (field === 'citime_cccd_front') {
                this.payer.cccd_front_url = url;
            } else if (field === 'citime_cccd_back') {
                this.payer.cccd_back_url = url;
            } else if (field === 'citime_birth_cert') {
                this.payer.birth_certificate_url = url;
            } else if (field === 'citime_receipt') {
                this.payer.receipt_url = url;
            }
        },

        cleanName(str) {
            return (str || '').toString().trim().toUpperCase().replace(/\s+/g, ' ');
        },
        cleanCCCD(str) {
            return (str || '').toString().replace(/\D/g, '');
        },
        formatDateFromOCR(vueDate) {
            if (!vueDate) return '';
            let strDate = String(vueDate).trim();
            let match = strDate.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
            if (match) {
                return `${match[3]}-${match[2]}-${match[1]}`; 
            }
            return strDate;
        },

        revalidatePayer() {
            if (this.scannedData.name && this.cleanName(this.payer.name) !== this.cleanName(this.scannedData.name)) {
                this.scanErrors.payer_name = 'Họ và tên không khớp với ảnh CCCD mặt trước';
            } else {
                this.scanErrors.payer_name = '';
            }

            if (this.scannedData.cccd && this.cleanCCCD(this.payer.cccd) !== this.cleanCCCD(this.scannedData.cccd)) {
                this.scanErrors.payer_cccd = 'Số CCCD không khớp với ảnh mặt trước';
            } else {
                this.scanErrors.payer_cccd = '';
            }
            if (this.scannedData.birthday && this.payer.birthday !== this.scannedData.birthday) {
                this.scanErrors.payer_birthday = 'Ngày sinh không khớp với ảnh CCCD mặt trước';
            } else {
                this.scanErrors.payer_birthday = '';
            }
        },
        revalidatePayerBack() {
            if (this.scannedData.cccd_issued_date && this.payer.cccd_issued_date !== this.scannedData.cccd_issued_date) {
                this.scanErrors.payer_cccd_issued_date = 'Ngày cấp không khớp với ảnh mặt sau CCCD';
            } else {
                this.scanErrors.payer_cccd_issued_date = '';
            }

            if (this.scannedData.cccd_issued_place && this.cleanName(this.payer.cccd_issued_place) !== this.cleanName(this.scannedData.cccd_issued_place)) {
                this.scanErrors.payer_cccd_issued_place = 'Nơi cấp không khớp với ảnh mặt sau CCCD';
            } else {
                this.scanErrors.payer_cccd_issued_place = '';
            }

            if (this.scannedData.id_number_back && this.cleanCCCD(this.payer.cccd) !== this.cleanCCCD(this.scannedData.id_number_back)) {
                this.scanErrors.payer_cccd_match = 'Dữ liệu ảnh mặt sau không khớp với mặt trước!';
            } else {
                this.scanErrors.payer_cccd_match = '';
            }
        },

        async processOCRFront(url) {
            try {
                this.$message.info("Đang đọc thông tin CCCD mặt trước...");
                const res = await this.$store.dispatch(SCAN_ID_CARD, { image_url: url });
                let scanData = res?.data?.data || res?.data || {};
                this.scannedData.name = scanData.full_name || res?.ocr?.full_name;
                this.scannedData.cccd = scanData.id_number || res?.ocr?.id_number;
                const dob = scanData.date_of_birth || res?.ocr?.date_of_birth;
                this.scannedData.birthday = dob ? this.formatDateFromOCR(dob) : '';
                this.revalidatePayer();
                this.$message.success("Đã phân tích ảnh CCCD mặt trước. Hệ thống sẽ cảnh báo đỏ nếu dữ liệu không khớp.");
            } catch (err) {
                console.error(err);
                this.$message.warning("Không thể đọc thông tin ảnh mặt trước, vui lòng nhập tay và kiểm tra cẩn thận.");
            }
        },

        async processOCRBack(url) {
            try {
                this.$message.info("Đang đọc thông tin CCCD mặt sau...");
                const res = await this.$store.dispatch(SCAN_ID_CARD_BACK, { image_url: url });
                let scanData = res?.data?.data || res?.data || {};
                const issueDate = scanData.date_of_issue || res?.ocr?.date_of_issue;
                this.scannedData.cccd_issued_date = issueDate ? this.formatDateFromOCR(issueDate) : '';
                this.scannedData.cccd_issued_place = scanData.place_of_issue || res?.ocr?.place_of_issue;
                this.scannedData.id_number_back = scanData.id_number || res?.ocr?.id_number;
                this.revalidatePayerBack();
                this.$message.success("Đã phân tích ảnh CCCD mặt sau. Hãy đối chiếu các thông tin.");
            } catch (err) {
                console.error(err);
                this.$message.warning("Không thể đọc thông tin ảnh mặt sau.");
            }
        },

        summit() {

            if (!this.payer.cccd_front_url) {
                this.errors.cccd_front_url = "Vui lòng tải lên ảnh mặt trước CCCD";
                return;
            }
            if (!this.payer.cccd_back_url) {
                this.errors.cccd_back_url = "Vui lòng tải lên ảnh mặt sau CCCD";
                return;
            }
            this.revalidatePayer();
            this.revalidatePayerBack();
            const activeErrors = Object.values(this.scanErrors).filter(err => err !== '');
            if (activeErrors.length > 0) {
                this.mismatchErrors = activeErrors;
                this.showMismatchDialog = true; 
                return;
            }
            this.executeSubmit();
        },

        async executeSubmit() {
            const payload = {
                id: this.id,
                payer: {
                    ...this.payer,
                    financial_proof_urls: this.payer.financial_proof_urls.filter(url => url !== '')
                }
            };
            try {
                this.isLoading = true;
                const res = await this.$store.dispatch(CONTRACT_CITIME_UPDATE_NEW_VERSION, payload);
                this.$message.success(res.message || "Cập nhật thông tin trả góp thành công!");
                this.$emit('success');
            } catch (e) {
                console.error(e);
                this.$message.error(e?.data?.message || 'Cập nhật thất bại');
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.update-citime-container {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
.el-select {
    width: 100%;
}
.upload-box {
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px !important;
    background-color: #fbfdff;
    cursor: pointer;
    transition: all 0.3s ease;
}

.upload-box:hover {
    border-color: #409EFF !important;
    background-color: #f0f7ff;
}

.upload-box .img-preview {
    max-width: 100%; 
    max-height: 100px; 
    object-fit: contain;
    border-radius: 4px;
}

.upload-box p {
    font-size: 14px;
    color: #606266;
}

.upload-box .small {
    font-size: 12px;
}
</style>